"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricPublisher = void 0;
var MetricPublisher = /** @class */ (function () {
    function MetricPublisher(katalPublisher) {
        this.katalPublisher = katalPublisher;
    }
    MetricPublisher.prototype.createChildPublisher = function (method) {
        return this.katalPublisher.newChildActionPublisherForMethod(method);
    };
    MetricPublisher.prototype.publishStringMetric = function (method, key, value) {
        var publisher = this.createChildPublisher(method);
        publisher.publishString(key, value);
    };
    MetricPublisher.prototype.publishCounterMetric = function (method, key, value) {
        var publisher = this.createChildPublisher(method);
        publisher.publishCounterMonitor(key, value);
    };
    MetricPublisher.prototype.publishTimerMetric = function (method, key, value) {
        var publisher = this.createChildPublisher(method);
        publisher.publishTimerMonitor(key, value);
    };
    return MetricPublisher;
}());
exports.MetricPublisher = MetricPublisher;
